import React, { useEffect, useState } from "react";
import { getStory } from "../../services/getStory";
import {
  Container,
  Modal,
  ModalBody,
  ModalHeader,
  Pagination,
  PaginationItem,
  PaginationLink,
} from "reactstrap";
import "react-multi-carousel/lib/styles.css";
import "../../Components/StudentStories.scss";
import ScrollTop from "../../Components/Buttons/ScrollTop";
import Reviewabanner from "./Reviewabanner";
import { getTestimonial } from "../../services/getAllTestimonial";
import ReactPlayer from "react-player";
import { FaRegPlayCircle } from "react-icons/fa";
import WorldWide from "../../Components/WorldWide";
import { Helmet } from "react-helmet";
import BreadCrumb from "../../Components/BreadCrumb/BreadCrumb";
import StorySlider from "./StorySlider";

const Reviews = () => {
  const [storyData, setStoryData] = useState([]);
  const [testimonialData, setTestimonialData] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [itemsPerPage] = useState(9);
  const fetchData = async () => {
    await getStory()
      .then((data) => {
        setStoryData(data.data);
      })
      .catch((error) => console.log(error));
  };
  const fetchTestimonialData = async () => {
    await getTestimonial()
      .then((data) => {
        setTestimonialData(data.data);
      })
      .catch((error) => console.log(error));
  };

  useEffect(() => {
    fetchData();
    fetchTestimonialData();
  }, []);

  const [isOpen, setIsOpen] = useState(false);
  const [videoUrl, setVideoUrl] = useState("");
  const [playingIndex, setPlayingIndex] = useState(null);

  const openModal = (url, index) => {
    setVideoUrl(url);
    setIsOpen(true);
    setPlayingIndex(index);
  };

  const closeModal = () => {
    setIsOpen(false);
    setVideoUrl("");
  };

  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const currentTestimonial = testimonialData.slice(
    indexOfFirstItem,
    indexOfLastItem,
  );
  const paginate = (pageNumber) => {
    setCurrentPage(pageNumber);
  };

  const breadCrumbData = [{ label: "Home", path: "/" }, { label: "Reviews" }];

  return (
    <div>
      <Helmet>
        <title>
          Reviews | Get Personalized Academic Success with DoubtQ | Online
          Question Help
        </title>
        <meta name="description" content="Welcome to the Reviews of DoubtQ" />
        <meta property="og:title" content="Reviews - DoubtQ" />
        <meta
          property="og:description"
          content="Explore personalized academic help on DoubtQ's Reviews"
        />
      </Helmet>
      {/* <Nav />
            <Navbar /> */}

      <div className="container">
        <div className="row mt-2 mb-2 m-0">
          <BreadCrumb items={breadCrumbData} />
        </div>
      </div>
      <Reviewabanner />
      <Container>
        <main className="rbt-main-wrapper questionAnswerjustify">
          <div className="student-stories-container banner">
            <div className="carousel-container pt-4 pb-4">
              <h1 className="text-center testimonial-title">Students Testimonials</h1>
              <div className="row d-flex justify-content-center">
                {currentTestimonial.map((e, index) => {
                  const isPlaying = index === playingIndex;
                  return (
                    <div key={index} className="col-lg-4 mt-4">
                      <div className="carousel-header">
                        <div
                          className="react-player-wrapper"
                          style={{ cursor: "pointer" }}
                        >
                          {isPlaying ? (
                            <ReactPlayer
                              url={e.videoLink}
                              light={true}
                              playIcon={
                                <i className="pay-icon">
                                  <FaRegPlayCircle />
                                </i>
                              }
                              width="100%"
                              height="200px"
                              className="react-player px-4"
                            />
                          ) : (
                            <div onClick={() => openModal(e.videoLink, index)}>
                              <ReactPlayer
                                url={e.videoLink}
                                light={true}
                                playIcon={
                                  <i className="pay-icon">
                                    <FaRegPlayCircle />
                                  </i>
                                }
                                width="100%"
                                height="200px"
                                className="react-player px-4"
                              />
                            </div>
                          )}
                        </div>
                      </div>
                    </div>
                  );
                })}
              </div>
              <div className="float-end mt-4">
                {testimonialData.length > itemsPerPage && (
                  <Pagination className="pagination justify-content-center">
                    <PaginationItem disabled={currentPage === 1}>
                      <PaginationLink
                        previous
                        onClick={() => paginate(currentPage - 1)}
                      />
                    </PaginationItem>
                    {Array(Math.ceil(testimonialData.length / itemsPerPage))
                      .fill()
                      .map((_, i) => (
                        <PaginationItem key={i} active={i + 1 === currentPage}>
                          <PaginationLink onClick={() => paginate(i + 1)}>
                            {i + 1}
                          </PaginationLink>
                        </PaginationItem>
                      ))}
                    <PaginationItem
                      disabled={
                        currentPage ===
                        Math.ceil(testimonialData.length / itemsPerPage)
                      }
                    >
                      <PaginationLink
                        next
                        onClick={() => paginate(currentPage + 1)}
                      />
                    </PaginationItem>
                  </Pagination>
                )}
              </div>
            </div>
            <StorySlider storyData={storyData} />
          </div>
        </main>
      </Container>
      <WorldWide />
      <ScrollTop />
      {/* <GetPopup /> */}
      <Modal
        isOpen={isOpen}
        toggle={closeModal}
        className="video-modal"
        size="lg"
      >
        <ModalHeader toggle={closeModal} className="popup-modal"></ModalHeader>
        <ModalBody>
          <ReactPlayer url={videoUrl} controls width="100%" height="400px" />
        </ModalBody>
      </Modal>
    </div>
  );
};

export default Reviews;
